import { common_urls, common_urls_cws2 } from 'src/environments/environment';
import { CWS2_ROUTES } from 'src/app/cws2.0/shared/cws2-routes.constants';

export const FAMILY_NAME_CHANGE_PROCEDURE_BASE_ROUTE = CWS2_ROUTES.FAMILY_NAME_CHANGE;

export const FAMILY_NAME_CHANGE_PROCEDURE_STEPPER_TRANSLATION_PREFIX = 'familyNameChangeProcedure.stepper.';
export const FAMILY_NAME_CHANGE_PROCEDURE_SCREEN_TYPE = FAMILY_NAME_CHANGE_PROCEDURE_BASE_ROUTE;

export const FAMILY_NAME_CHANGE_PROCEDURE_STEP_NAMES = ['step1', 'step2'] as const;

export const FAMILY_NAME_CHANGE_PROCEDURE_ROUTES = {
  DETAILS: 'details',
  CONFIRMATION: 'confirmation',
  COMPLETION: 'completion',
} as const;

export const FAMILY_NAME_CHANGE_PROCEDURE_STEP_INDEX = {
  DETAILS: 0,
  CONFIRMATION: 1,
} as const;

export const FAMILY_NAME_CHANGE_PROCEDURE_API_URLS = {
  LOAD_FAMILY_NAME_CHANGE: `${common_urls_cws2.bffBaseUrl_mvp3}/load/family-name-change`,
  SUBMIT_FAMILY_NAME_CHANGE: `${common_urls_cws2.bffBaseUrl_mvp3}/submit/family-name-change`,
  CWS_HOME: `${common_urls.cwsBaseUrl}/home?From=auth&cws=1`,
  CWS_EMAIL_ENQUIRY: `${common_urls.cwsBaseUrl}/emailinquiry?from=home`,
} as const;
